import axios from "axios";
import { getAuthHeader, RESET_PASSWORD_URL } from "../../configuration/Utils/constService";

export const resetPassword = (data) => axios.post(RESET_PASSWORD_URL, data, getAuthHeader());